import React from "react";
import "./css/index.css";
function Emty() {
  return (
    <div className="emty-box">
      <img src="/assets/common/emty.svg" alt="" />
      <div className="title">내용이 존재하지 않습니다</div>
    </div>
  );
}

export default Emty;
